/**
 * Country Life Plus — savings calculator ("The Savings Ledger").
 * Two range inputs drive a live readout inside [data-clp-calculator].
 * Config (price, rates) and verdict copy come from data-* attributes set by
 * sections/clp-calculator.liquid; all money is whole dollars with thousands
 * separators. No framework, no dependencies.
 */
(function () {
  'use strict';

  function money(v) {
    return '$' + Math.round(v).toLocaleString('en-US');
  }

  function initCalculator(root) {
    if (!root || root.dataset.clpInit === '1') return;
    root.dataset.clpInit = '1';

    var spendRange = root.querySelector('[data-clp-spend-range]');
    var ordersRange = root.querySelector('[data-clp-orders-range]');
    if (!spendRange || !ordersRange) return;

    var price = parseFloat(root.dataset.price) || 99;
    var shipPer = parseFloat(root.dataset.ship) || 0;
    var creditRate = parseFloat(root.dataset.credit) || 0;
    var saleRate = parseFloat(root.dataset.sale) || 0;
    var priceLabel = root.dataset.priceLabel || money(price);
    var gaugeTemplate = root.dataset.gaugeTemplate || '{pct}% of your {price} in cash alone';

    var spendLabel = root.querySelector('[data-clp-spend-label]');
    var ordersLabel = root.querySelector('[data-clp-orders-label]');
    var outs = {
      ship: root.querySelector('[data-clp-out="ship"]'),
      credits: root.querySelector('[data-clp-out="credits"]'),
      sales: root.querySelector('[data-clp-out="sales"]'),
      total: root.querySelector('[data-clp-out="total"]')
    };
    var fill = root.querySelector('[data-clp-fill]');
    var gaugeLabel = root.querySelector('[data-clp-gauge-label]');
    var verdictTitle = root.querySelector('[data-clp-verdict-title]');
    var verdictNum = root.querySelector('[data-clp-verdict-num]');
    var verdictSub = root.querySelector('[data-clp-verdict-sub]');

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function update() {
      var spend = parseFloat(spendRange.value) || 0;
      var orders = parseFloat(ordersRange.value) || 0;

      var ship = orders * shipPer;
      var credits = spend * creditRate;
      var sales = spend * saleRate;
      var total = ship + credits + sales;
      var net = total - price;
      var pctBack = Math.round((total / price) * 100);
      var fillPct = Math.min(100, pctBack);
      var isAhead = net >= 0;

      setText(spendLabel, money(spend));
      setText(ordersLabel, String(orders));
      setText(outs.ship, money(ship));
      setText(outs.credits, money(credits));
      setText(outs.sales, money(sales));
      setText(outs.total, money(total));

      if (fill) fill.style.width = fillPct + '%';
      setText(
        gaugeLabel,
        gaugeTemplate.replace('{pct}', pctBack).replace('{price}', priceLabel)
      );

      setText(verdictTitle, isAhead ? root.dataset.aheadTitle : root.dataset.behindTitle);
      setText(verdictNum, isAhead ? '+' + money(net) : pctBack + '%');
      setText(verdictSub, isAhead ? root.dataset.aheadSub : root.dataset.behindSub);
    }

    spendRange.addEventListener('input', update);
    ordersRange.addEventListener('input', update);
    update();
  }

  function initAll(context) {
    var roots = (context || document).querySelectorAll('[data-clp-calculator]');
    for (var i = 0; i < roots.length; i++) initCalculator(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-init when the section is re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
